import { createSelector } from 'reselect'
import getMerchandiseItemViews from '../view/itemViews/getMerchandiseItemViews'
import { sum } from 'lib/array/arrayUtils'
import getMerchandiseShippingItemViews from '../view/itemViews/getMerchandiseShippingItemViews'

const getMerchandiseTotals = createSelector(
  (state: App.State) => getMerchandiseItemViews(state),
  (state: App.State) => getMerchandiseShippingItemViews(state),
  (merchandiseViews, merchandiseShippingViews): App.WithDataStatus<App.Checkout.ItemViewTotals> => {
    return {
      hasRequiredData: merchandiseViews.hasRequiredData && merchandiseShippingViews.hasRequiredData,
      data: {
        price: sum(merchandiseViews.data, view => view.totals.price),
        memberPrice: 0,
        value: sum(merchandiseViews.data, view => view.totals.value),
        memberValue: 0,
        surcharge: 0,
        extraGuestSurcharge: 0,
        taxesAndFees: 0,
        otherFees: {
          deliveryFee: sum(merchandiseShippingViews.data, view => view.totals.otherFees?.deliveryFee ?? 0),
        }
      },
    }
  }
)
export default getMerchandiseTotals
